import React from 'react'
import Popup from 'components/ui-kit/Popup/index'
import Button from 'components/ui-kit/Button/index'
import './TimeoutModal.scss';
import { useTranslation } from 'react-i18next';

const TimeOutModal = ({ isOpen }) => {
  const {t} = useTranslation();
  return (
    <Popup isOpenModal={isOpen} className='mine-timeout-modal text-center'>
      <h4 className='mine-settings-heading mb-4'>{t('CONNECTION_LOST')}</h4>
      <p className='mb-4'>{t('PLEASE_CHECK_YOUR_INTERNET_AND_TRY_AGAIN')}</p>
      <Button
        className='btn-ok-mine w-100 d-flex justify-content-center align-items-center'
        type='button'
        onClick={() => window.location.reload()}
      >
        {t('RELOAD')}
      </Button>
    </Popup>
  )
}

export default TimeOutModal
